import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/_services';
import { CartService } from '@app/_services/cart.service';
import { QuotationCartService } from '@app/_services/quotation.service';
import { ToastRef, ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import * as _ from 'lodash'
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { PropertyService } from '@app/_services/property.service';
import { CurrencyFormatPipe } from '../../../../../shared/pipes/currency-format.pipe';
import { MatTabsModule } from '@angular/material/tabs';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgFor, DatePipe } from '@angular/common';
@Component({
    selector: 'app-property-contract-details',
    templateUrl: './property-details.component.html',
    styleUrls: ['./property-details.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, FlexModule, MatTabsModule, NgFor, DatePipe, CurrencyFormatPipe, TranslateModule]
})
export class PropertyDetailsComponent {
    userDetails;
    addingToCart: any;
    loading = true;
    constructor(
        private authService: AuthenticationService,
        public propertyService: PropertyService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private toastr: ToastrService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private route: ActivatedRoute
    ) {}


    invoices = [];
    receipts = [];
    propertyContracts=[];
    propertyContract;
    pageType;
    status = {
        new: {
            color: '#125077',
            text: 'New',
        },
        open: {
            color: '#9E6DEB',
            text: 'Open',
        },
        offered: {
            color: '#ff5900',
            text: 'Offered',
        },
        accepted: {
            color: '#079008',
            text: 'Accepted',
        },
        inprogress: {
            color: '#6D9EEB',
            text: 'In-Progress',
        },
        rejected: {
            color: '#ff0202',
            text: 'Rejected',
        },

        cancelled: {
            color: '#ff0202',
            text: 'Cancelled',
        },
        renegotiated: {
            color: '#0095a0',
            text: 'Renegotiated',
        },
    };

    _=_
    property;
    ngOnInit(): void {
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });

        this.activeRoute.params.subscribe((result) => {
            this.property=result.id
        });
        this.pageType = this.route.snapshot.data['feature'];

        this.loadPropertyDetails(this.property)
    }

    getContractType(type) {
        if(type == 'management'){
            return "Management"
        }else if(type == 'rent'){
            return "Rent"
        }
    }

    loadPropertyDetails(id) {
        this.loading = true;
        this.propertyService.getPropertyDetails(this.pageType,id).subscribe(
            (data) => {
                if (data) {
                    this.loading = false;

                    this.propertyContract = data.data.propertyContract;
                    this.invoices = this.propertyContract?.invoices;
                    this.receipts = this.propertyContract?.receipts;
                    this.propertyContracts = this.propertyContract?.propertyContracts;
                    //console.log('QuotationDetails: ' + JSON.stringify(data));
                } else {
                    this.toastr.error('Error getting Data');
                    this.loading = false;
                }
            },
            (error) => {
                this.loading = false;
                this.toastr.error('Error getting Data');
                console.log(error);
            }
        );
    }


}
